module.exports = __webpack_public_path__ + "img/06-01_Being Politically Astute.46965e74.svg";